import { messages } from './messages';

// Backend may return this value when no option is selected
export const REGULATED_CONTENT_TYPE_NONE_VALUE = 'None';

export const REGULATED_CONTENT_TYPES = [
  {
    id: 'DayOldPoultry',
    label: messages.regulatedContentTypeDayOldPoultry,
  },
  {
    id: 'OtherLiveAnimal',
    label: messages.regulatedContentTypeOther,
  },
];
